import { useAuthContext } from "src/auth/AuthContext";
import { transferMoveService } from 'src/service/TransferMoveService';
import TransfersMoveForm from "./TransfersMoveForm";

const TransfersMoveAdd = () => {
    const { user } = useAuthContext();
    return <TransfersMoveForm transferMoveId={-1} organizationId={user.data.organizationId} onSubmit={(ps) => transferMoveService.add(ps)} header='Neuer Übertrag' />
}

export default TransfersMoveAdd